module.exports = __webpack_public_path__ + "img/EGCSScrubber.76afdb28.svg";